import { useQuery } from '@tanstack/react-query';

import { chatQueryKeys, getChatConversations } from 'services/api/chat';

/**
 * The referral's chat channels (OLIO-2832): one conversation per facility the referral
 * was sent to, policy-scoped server-side so only channels the user can see come back.
 * Mounted at page level so a later story's tab badge reads from the same cache. Read-only
 * in v1 — no messages, composer, or realtime yet.
 */
export default function useChatConversations(id: string | undefined) {
  const query = useQuery({
    queryKey: chatQueryKeys.index(id ?? 'missing'),
    queryFn: ({ signal }) => getChatConversations(id!, signal),
    enabled: !!id,
  });

  return {
    conversations: query.data ?? [],
    isLoading: query.isPending && !!id,
    isError: query.isError,
  };
}
